import React, { Component } from 'react';
import { RouteComponentProps } from '@reach/router';
import RomsList from './list';
// import RomsSearch from './search';
import { ROM_PATH_CREATE } from 'routes/paths';
import { HasPermission } from 'shared/HasPermission';
import { Link } from '@reach/router';
import { Button, Row, Col } from '@nackle/paper';
class RomListWrapper extends Component<RouteComponentProps> {
    render() {
        return (
            <div>
                <Row justify={'space-between'} className={'nkl-mx-5 nkl-mb-5'}>
                    <Col sm={11}>
                        {/* <RomsSearch /> */}
                    </Col>
                    <Col sm={11} lg={5}>
                        <HasPermission app="arcade-api" permission="create-rom">
                            {(hasPermission: boolean) => hasPermission &&
                                <Link
                                    className='button intent-primary'
                                    to={'.' + ROM_PATH_CREATE}
                                    id="add-new-game-rom-button"
                                >
                                    <Button style={ { width: '100%', height: '100%' } } type="primary">
                                    Add New Game ROM
                                    </Button>

                                </Link>
                            }
                        </HasPermission>
                    </Col>
                </Row>
                <RomsList />
            </div>
        );
    }
}

export default RomListWrapper;
